import React from 'react';
import './Footer.css';
const Footer = () => {
    return (
        <footer className='footer'>
            <p>All rights reserved &copy; Hero3 Transport Group -2021</p>
        </footer>
    );
};

export default Footer;